import { AxDropdown, AxFormValidation } from "@axess/limestone";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { MeasurementHelper } from "../../Lib/Helper/MeasurementHelper";
import { PriceHelper } from "../../Lib/Helper/PriceHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { CrossSaleRequestHelper, ICrossSaleRequest } from "../../Lib/Helper/AxProdSelection/CrossSaleRequestHelper";
import { AxLoading } from "../../Limestone/AxLoading/AxLoading";
import { ProductTripleWithType } from "../../Models/Products/ProductTripleWithType";
import { CustomerLessonProperties, LessonProperty } from "../Account/CustomerLessonProperties";

interface ILessonPersonalizationInitData {
    datepickerFormat: string;
    datepickerLanguage: string;
    datepickerWeekStart: number;
    dto: LessonAddToCartDto;
}

class LessonAddToCartDto {
    lessonNr: number;
    lessonWebNr: number;
    lessonArcNr: number;
    lessonDefNr: number;
    lessonAddToCartProducts: LessonAddToCartProducts[] = [];
    CrossSale?: ICrossSaleRequest;
}

class LessonAddToCartProducts extends ProductTripleWithType {
    subTypeIdentifier: number;
    person: LessonAddToCartPerson;
    additions: LessonAddToCartProductAddition[] = [];
}

class LessonAddToCartProductAddition {
    packagePositionNr: number;
}

class LessonAddToCartPerson {
    accountId: number;

    firstName: string;
    lastName: string;
    dateOfBirth: string;

    gender?: string;
    height?: string | null;
    weight?: string | null;
    shoeSize?: string | null;
    lessonAllergies?: LessonProperty[] = [];
    lessonLanguages?: LessonProperty[] = [];
    lessonMedicals?: LessonProperty[] = [];
    lessonLevels?: LessonProperty[] = [];

    emergencyContactAccountId?: number;
    emergencyName?: string | null;
    emergencyEmail?: string | null;
    emergencyPhone?: string | null;
    instructor?: string | null;
    instructorProjNr?: number | null;
    instructorNr?: number | null;
    goal?: string | null;
}

interface LessonContactPerson {
    AccountId: number;
    FirstName: string;
    LastName: string;
    Email: string;
    Phone: string;
}

const NEW_PERSON_ACCOUNT_ID = 0;

@ModuleName("LessonsPersonalization")
export class LessonPersonalization implements AxInit {
    private initData: ILessonPersonalizationInitData;
    private personDropDown = new AxDropdown();
    private contactDropDown = new AxDropdown();
    private instructorDropDown = new AxDropdown();
    private levelDropDown = new AxDropdown();
    private weightDropDown: AxDropdown = new AxDropdown();
    private heightDropDown: AxDropdown = new AxDropdown();
    private showSizeDropDown: AxDropdown = new AxDropdown();
    private measurementHelper: MeasurementHelper = new MeasurementHelper();

    private propertyModules: CustomerLessonProperties[][] = [];

    constructor(private _priceHelper = new PriceHelper(null, true),
        private _requestHelper = new RequestHelper(),
        private _axLoading = new AxLoading(),
        private _i18nHelper = new I18nHelper(),) {

    }

    AxInit(init?: ILessonPersonalizationInitData): void {
        this.initData = init as ILessonPersonalizationInitData;

        $('[data-lesson="personalization-person-btn"]').on('click', (e) => {
            const $button = $(e.delegateTarget);
            this.toggleActivePerson($button);
        });

        $('[data-lesson="personalization-person-wrapper"]').on('change', '[data-lesson="unit-system"]', (e) => {
            const $radio = $(e.currentTarget);
            const selectedUnit = $radio.val() as number;
            const originalUnit = selectedUnit == UnitSystemEnum.Imperial ? UnitSystemEnum.Metric : UnitSystemEnum.Imperial;
            const index = parseInt($radio.attr('data-index') as string);
            const $target = $(`[data-lesson="personalization-person-form"][data-index="${index}"]`)

            const shoeSize = $target.find(`input[name="ParticipantInfos[${index}].ShoeSize"]`).val() as string;
            let weight = $target.find(`input[name="ParticipantInfos[${index}].Weight"]`).val() as string;
            let height = $target.find(`input[name="height-${index}"]`).val() as string;
            if (originalUnit == UnitSystemEnum.Imperial) {
                const heightFeet = Number($target.find(`input[name="heightFeet-${index}"]`).val() as string);
                const heightInch =  Number($target.find(`input[name="heightInch-${index}"]`).val() as string);
                const totalInches = this.measurementHelper.feetAndInchesToTotalInches(heightFeet, heightInch);
                weight = this.measurementHelper.lbsToKg(Number(weight as string)).toString()
                height = this.measurementHelper.inchesToMeters(totalInches).toString();
            }

            AxessViewer.loadPartialView('/Products/Lessons/GetAccRentalInfo', {
                unit: selectedUnit,
                index: index,
                rentalViewModel: {
                    height: height,
                    weight: weight,
                    shoeSize: shoeSize,
                }
            }, (resp) => {
                $('[data-lesson="personalization-rental"]').html(resp.view);
                this.initRentDropdowns();
            });
        });

        this.initCustomerProps();
        this.initPersonDropDown();
        this.initContactDropDown();
        this.initInstructorDropDown();
        this.initDatePicker();
        this.updatePriceSummary();
        this.initRentDropdowns();
        this.initFormValidation();
    }

    initFormValidation() {
        for (let form of $('[data-lesson="personalization-person-content"]')) {
            const index = parseInt($(form).attr('data-index') as string);

            const formValidator = new AxFormValidation({
                selector: `[data-lesson="personalization-person-form"][data-index="${index}"]`,
                rules: {},
                callback: (form: HTMLElement) => {
                    // personal data is disabled (and therefore not validated) until a person is selected
                    if (!this.isPersonSelected(index)) {
                        this.getPersonDropdown(index).find('.ax-dropdown__trigger').trigger('click');
                        return;
                    }

                    const $currentButton = $(`[data-lesson="personalization-person-btn"][data-index=${index}]`);
                    $currentButton.find('i').removeClass('d-none');

                    if ($(form).is('[data-lesson-personalization="next"]')) {
                        const nextIndex = index + 1;
                        const $button = $(`[data-lesson="personalization-person-btn"][data-index=${nextIndex}]`);
                        this.toggleActivePerson($button);
                    } else {
                        this.submit();
                    }
                }
            }).init();

            this.applyRules(index);
        }
    }

    initCustomerProps() {
        let index = 0;
        for (const personWrapper of $('[data-lesson="personalization-person-wrapper"]')) {
            const $personWrapper = $(personWrapper);
            const target = $personWrapper.attr('data-target') as string;

            const customerLessonProps = new CustomerLessonProperties();
            customerLessonProps.AxInit({
                parentId: `[data-lesson="personalization-person-wrapper"][data-target="${$personWrapper.attr('data-target')}"]`,
                formElementPrefix: `ParticipantInfos[${index}].`
            });

            this.propertyModules[target] = customerLessonProps;
            index++;

            $personWrapper.on('change', '[data-lesson="personalization-addProduct"]', (e) => {
                const $orgTarget = $(e.delegateTarget);
                const target = $orgTarget.attr('data-target');

                const $checkbox = $(e.currentTarget);
                const isChecked = $checkbox.prop('checked');
                const pos = $checkbox.val();

                $(`[data-lesson-summary="opt-item"][data-target="${target}"][data-value="${pos}"]`)
                    .toggleClass('d-none', !isChecked)
                    .toggleClass('d-flex', isChecked)
                    .attr('data-active', isChecked ? "true" : "false");
                this.updatePriceSummary();
            });
        }

        this.levelDropDown.init(`[data-lesson="personalization-level-drpdwn"]`, {
            searchBar: false,
            multiSelect: false,
        });
    }

    initDatePicker() {
        $('[data-lesson="personalization-person-dob"]').datepicker({
            format: this.initData.datepickerFormat,
            language: this.initData.datepickerLanguage,
            weekStart: this.initData.datepickerWeekStart
        });
    }

    initPersonDropDown() {
        this.personDropDown = new AxDropdown();

        this.personDropDown.init(`[data-lesson="personalization-person-drpdwn"]`, {
            searchBar: false,
            multiSelect: false,
            onSelect: ($elem: JQuery<HTMLElement>, value) => {
                const accountId = parseInt(value.toString());
                const index = parseInt($elem.attr('data-index') as string);
                const target = $elem.attr('data-target') as string;
                const subTypeIdentifier = $elem.attr('data-identifier') as string;

                this.loadPerson(index, accountId, target, subTypeIdentifier);
            }
        });
    }

    getPersonDropdown(index: number): JQuery<HTMLElement> {
        return $(`[data-lesson="personalization-person-drpdwn"][data-index="${index}"]`);
    }

    isPersonSelected(index: number): boolean {
        const value = this.personDropDown.getValue(this.getPersonDropdown(index));
        return value !== undefined && value !== null && value.toString() !== '';
    }

    // fields that are not personal data (contact, instructor, goals) are kept when the selected person changes
    getNonPersonalDataValues($target: JQuery<HTMLElement>, index: number): Record<string, string> {
        const values: Record<string, string> = {};

        for (const field of ['EmergencyName', 'EmergencyEmail', 'EmergencyPhone', 'Instructor', 'Goal']) {
            values[field] = $target.find(`[name="ParticipantInfos[${index}].${field}"]`).val() as string;
        }

        return values;
    }

    setNonPersonalDataValues($target: JQuery<HTMLElement>, index: number, values: Record<string, string>) {
        for (const field of Object.keys(values)) {
            $target.find(`[name="ParticipantInfos[${index}].${field}"]`).val(values[field]);
        }
    }

    // only rendered when AxCore returns instructors for the lesson type, otherwise the instructor is free text
    initInstructorDropDown(index?: number) {
        const selector = typeof index === 'undefined'
            ? `[data-lesson="personalization-instructor-drpdwn"]`
            : `[data-lesson="personalization-instructor-drpdwn"][data-index="${index}"]`;

        this.instructorDropDown = new AxDropdown();
        this.instructorDropDown.init(selector, {
            searchBar: false,
            multiSelect: false,
        });
    }

    // dropdown value: "<projNr>_<instructorNr>", empty for no preference
    getSelectedInstructorValue(index: number): string {
        const $instructorDropdown = $(`[data-lesson="personalization-instructor-drpdwn"][data-index="${index}"]`);
        if ($instructorDropdown.length === 0) {
            return '';
        }

        return (this.instructorDropDown.getValue($instructorDropdown) as string) ?? '';
    }

    getSelectedInstructor(index: number): { projNr: number, instructorNr: number } | null {
        const [projNr, instructorNr] = this.getSelectedInstructorValue(index).split('_').map(x => parseInt(x));
        return isNaN(projNr) || isNaN(instructorNr) ? null : { projNr, instructorNr };
    }

    initContactDropDown(index?: number) {
        const selector = typeof index === 'undefined'
            ? `[data-lesson="personalization-contact-drpdwn"]`
            : `[data-lesson="personalization-contact-drpdwn"][data-index="${index}"]`;

        this.contactDropDown = new AxDropdown();

        this.contactDropDown.init(selector, {
            searchBar: false,
            multiSelect: false,
            onSelect: ($elem: JQuery<HTMLElement>, value) => {
                const index = parseInt($elem.attr('data-index') as string);
                this.applyContactPerson(index, parseInt(value.toString()));
            }
        });
    }

    getContactDropdown(index: number): JQuery<HTMLElement> {
        return $(`[data-lesson="personalization-contact-drpdwn"][data-index="${index}"]`);
    }

    getContactPersons(index: number): LessonContactPerson[] {
        return JSON.parse(this.getContactDropdown(index).attr('data-contacts') ?? '[]') as LessonContactPerson[];
    }

    getSelectedContactAccountId(index: number): number {
        const $contactDropdown = this.getContactDropdown(index);
        if ($contactDropdown.length === 0) {
            return NEW_PERSON_ACCOUNT_ID;
        }

        const value = parseInt(this.contactDropDown.getValue($contactDropdown) as string);
        return isNaN(value) ? NEW_PERSON_ACCOUNT_ID : value;
    }

    // a family member fills in the contact data, "new person" clears it to be entered (and created as family member on add to cart)
    applyContactPerson(index: number, accountId: number) {
        const contactPerson = this.getContactPersons(index).find(x => x.AccountId === accountId);
        const $target = $(`[data-lesson="personalization-person-content"][data-index="${index}"]`);

        const name = contactPerson ? `${contactPerson.FirstName ?? ''} ${contactPerson.LastName ?? ''}`.trim() : '';
        $target.find(`[name="ParticipantInfos[${index}].EmergencyName"]`).val(name);
        $target.find(`[name="ParticipantInfos[${index}].EmergencyEmail"]`).val(contactPerson?.Email ?? '');
        $target.find(`[name="ParticipantInfos[${index}].EmergencyPhone"]`).val(contactPerson?.Phone ?? '');
    }

    loadPerson(index: number, accountId: number, target: string, subTypeIdentifier: string, unitInt?: number) {
        const $target = $(`[data-lesson="personalization-person-content"][data-index="${index}"]`);
        const nonPersonalDataValues = this.getNonPersonalDataValues($target, index);
        const contactAccountId = this.getSelectedContactAccountId(index);
        const instructorValue = this.getSelectedInstructorValue(index);

        this._axLoading.ShowLoadingIndicator($target[0], false)

        AxessViewer.loadPartialView('/Products/Lessons/PersonalizationPartial', {
            r: this._requestHelper.findGetParameter('r'),
            customerAccountNr: accountId,
            index: index,
            subTypeIdentifier: subTypeIdentifier,
            unitInt: unitInt
        }, (resp) => {
            this._axLoading.HideLoadingIndicator($target[0]);

            $target.html(resp.returnView);
            this.setNonPersonalDataValues($target, index, nonPersonalDataValues);
            this.applyRules(index);
            this.initContactDropDown(index);
            this.restoreContactPerson(index, contactAccountId);
            this.initInstructorDropDown(index);
            if (instructorValue) {
                this.instructorDropDown.setValue(instructorValue, $(`[data-lesson="personalization-instructor-drpdwn"][data-index="${index}"]`));
            }
            this.initCustomerProps();
            this.initRentDropdowns();
            this.initDatePicker();

            for (let optionalItem of $(`[data-lesson="summary-accordion"] [data-lesson-summary="opt-item"][data-target="${target}"]`)) {
                const $optionalItem = $(optionalItem);
                const value = $optionalItem.attr('data-value');
                const active = (/true/).test($optionalItem.attr('data-active') as string);

                $target.find(`[data-lesson="personalization-addProduct"][value="${value}"]`).prop('checked', active);
            }
            this.updatePriceSummary();
        });
    }

    // keeps the selected contact if it is still available, otherwise (it is now the participant) falls back to "new person"
    restoreContactPerson(index: number, contactAccountId: number) {
        if (contactAccountId === NEW_PERSON_ACCOUNT_ID) {
            return;
        }

        if (this.getContactPersons(index).some(x => x.AccountId === contactAccountId)) {
            this.contactDropDown.setValue(contactAccountId.toString(), this.getContactDropdown(index));
        } else {
            this.applyContactPerson(index, NEW_PERSON_ACCOUNT_ID);
        }
    }

    toggleActivePerson($button: JQuery<HTMLElement>) {
        const target = $button.attr('data-target');

        $('[data-lesson="personalization-person-btn"]').removeClass('ax-btn-primary').addClass('ax-btn-secondary');
        $button.addClass('ax-btn-primary').removeClass('ax-btn-secondary');

        $('[data-lesson="personalization-person-wrapper"]').removeClass('d-flex ').addClass('d-none');
        $(`[data-lesson="personalization-person-wrapper"][data-target="${target}"]`).addClass('d-flex ').removeClass('d-none');
    }

    updatePriceSummary() {
        const $priceHolder = $('[data-lesson-summary="price"]');
        const basePrice = parseInt($priceHolder.attr('data-tariff') as string);
        let newPrice = basePrice;

        for (let optionalItem of $('[data-lesson="summary-accordion"] [data-lesson-summary="opt-item"][data-active="true"]')) {
            const $optionalItem = $(optionalItem);
            const itemPrice = parseInt($optionalItem.attr('data-tariff') as string);

            newPrice += itemPrice;
        }

        $priceHolder.html(this._priceHelper.GetPriceStringWithCurrencySymbol(newPrice / 100));
    }

    submit() {
        let index = 0;
        const selectedUnit = $('input[data-lesson="unit-system"]:checked').val() as number;

        for (let product of this.initData.dto.lessonAddToCartProducts) {
            const productIdentifier = `${product.projNr}/${product.productGroupIdentifier}/${product.id}/${product.subTypeIdentifier}/${index}`;

            const $target = $(`[data-lesson="personalization-person-wrapper"][data-target="${productIdentifier}"]`);
            const $personDropdown = $target.find('[data-lesson="personalization-person-drpdwn"]');

            const customerAccountNr = parseInt((this.personDropDown.getValue($personDropdown) as string));

            const firstName = $target.find(`input[name="ParticipantInfos[${index}].FirstName"]`).val();
            const lastName = $target.find(`input[name="ParticipantInfos[${index}].LastName"]`).val();
            const dob = $target.find(`input[name="ParticipantInfos[${index}].DateOfBirth"]`).val();

            const shoeSize = $target.find(`input[name="ParticipantInfos[${index}].ShoeSize"]`).val() as string;
            let weight = $target.find(`input[name="ParticipantInfos[${index}].Weight"]`).val() as string;
            const $height = $target.find(`input[name="height-${index}"]`).length > 0
                ? $target.find(`input[name="height-${index}"]`)
                : $target.find(`input[name="ParticipantInfos[${index}].Height"]`)
            let height = $height.val() as string;
            if (!height && selectedUnit == UnitSystemEnum.Imperial) {
                const heightFeet = Number($target.find(`input[name="heightFeet-${index}"]`).val() as string);
                const heightInch =  Number($target.find(`input[name="heightInch-${index}"]`).val() as string);
                const totalInches = this.measurementHelper.feetAndInchesToTotalInches(heightFeet, heightInch);
                weight = this.measurementHelper.lbsToKg(Number(weight as string)).toString()
                height = this.measurementHelper.inchesToMeters(totalInches).toString();
            }

            const emergencyName = $target.find(`input[name="ParticipantInfos[${index}].EmergencyName"]`).val() as string;
            const emergencyEmail = $target.find(`input[name="ParticipantInfos[${index}].EmergencyEmail"]`).val() as string;
            const emergencyPhone = $target.find(`input[name="ParticipantInfos[${index}].EmergencyPhone"]`).val() as string;
            const instructor = $target.find(`input[name="ParticipantInfos[${index}].Instructor"]`).val() as string;
            const selectedInstructor = this.getSelectedInstructor(index);
            const goal = $target.find(`textarea[name="ParticipantInfos[${index}].Goal"]`).val() as string;

            const propertyModule: CustomerLessonProperties = this.propertyModules[productIdentifier];

            product.person = {
                accountId: customerAccountNr,
                firstName: firstName as string,
                lastName: lastName as string,
                dateOfBirth: dob as string,
                height: height,
                weight: weight,
                shoeSize: shoeSize,
                lessonAllergies: propertyModule.allergies,
                lessonLanguages: propertyModule.languages,
                lessonLevels: propertyModule.lessonLevels,
                lessonMedicals: propertyModule.medicalStates,

                emergencyContactAccountId: this.getSelectedContactAccountId(index),
                emergencyName: emergencyName,
                emergencyEmail: emergencyEmail,
                emergencyPhone: emergencyPhone,
                instructor: instructor,
                instructorProjNr: selectedInstructor?.projNr ?? null,
                instructorNr: selectedInstructor?.instructorNr ?? null,
                goal: goal,
            };

            const addProducts = $target.find('[data-lesson="personalization-addProduct"]:checked');
            product.additions = [];
            for (let addProd of addProducts) {
                product.additions.push({
                    packagePositionNr: parseInt($(addProd).attr('value') as string),
                });
            }
            index++;
        }

        const $submitButton = $('[data-lesson="personalization-submit"]');

        this._axLoading.ShowLoadingIndicatorButtonPrimary($submitButton[$submitButton.length - 1]);
        // cross-sale reference kept from the details page url, validated again by the server
        CrossSaleRequestHelper.addToRequest(this.initData.dto);
        AxessViewer.loadPartialView('/Products/Lessons/AddToCart', {
            model: this.initData.dto,
        }, (resp) => {
            this._axLoading.HideLoadingIndicator($submitButton[$submitButton.length - 1]);
            AxLoad.LoadModule('AxFireShoppingCartModal', {
                result: resp,
                continueShoppingPath: 'Lessons',
                btn: '.lessons_add_to_cart_form',
                ResetQuantity: undefined,
            });
        }, {
            silent: true,
            skipShoppingCartReload: false,
        });
    }


    applyRules(index: number) {
        const $firstname = $(`#ParticipantInfos_${index}__Emergency_Email`);
        // the emergency contact can be disabled by configuration
        if ($firstname.length === 0) {
            return;
        }

        // required depends on configuration (rendered as attribute), the format is only checked when there is a value
        const hasValue = (element: HTMLElement) => ($(element).val() as string ?? '').trim() !== '';

        $firstname.rules('add', {
            required: $firstname.prop('required') === true,
            email: { param: true, depends: hasValue },
            regex: { param: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i, depends: hasValue },
            messages: {
                email: this._i18nHelper.GetTranslation(Translations.I18NextMsgEmail),
                regex: this._i18nHelper.GetTranslation(Translations.I18NextMsgEmail),
            }
        });
    }

    initRentDropdowns() {
        this.weightDropDown.init(`.prod_selection__weight-selection`, {
            searchBar: false,
            multiSelect: false,
        });

        this.heightDropDown.init(`.prod_selection__height-selection`, {
            searchBar: false,
            multiSelect: false,
        });

        this.showSizeDropDown.init(`.prod_selection__shoeSize-selection`, {
            searchBar: false,
            multiSelect: false,
        });
    }
}

enum UnitSystemEnum {
    Metric = 0,
    Imperial = 1
}